<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { Primitive, type PrimitiveProps, useForwardProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<PrimitiveProps & { class?: HTMLAttributes["class"] }>()
const forwardedProps = useForwardProps(() => props)

const className = useClass(
	"flex items-center",
	() => rawClass,
)
</script>

<template>
	<Primitive
		v-bind="forwardedProps"
		:class="className">
		<slot />
	</primitive>
</template>
